
<template>
  <div class="upload">
    <!-- 上传触发的按钮 uploadtag -->
    <slot />
    <input ref="file" type="file" title="" :multiple="multiple" style="height: 100%;" :accept="accept" @change="seleteFiles">
  </div>
</template>
<script>
import { uploadFile } from '@/utils/upload.js'
import { defineComponent, toRefs, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
// 本组件中,默认1为视频 2音频 3图片 4文件
export default defineComponent({
  name: 'FileUpload',
  props: {
    accept: {
      type: String,
      default: ''
    },
    fileSize: {
      type: [String, Number],
      default: 100
    },
    // fileType: {
    //   type: Array,
    //   default: () => ['png', 'bmp', '''jpg', 'jpeg', 'pdf', 'jfif', 'tiff', 'heic', 'gif', 'application/zip', 'xlsx', 'zip', 'rar','application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'vnd.ms-excel', 'doc', 'docx', 'xls']
    // },
    height: {
      type: String,
      default: '50'
    },
    // 最大可上传图片数量
    maxNum: {
      type: [Number, String],
      default: 0
    },
    // 当前已上传数量
    filesLength: {
      type: [Number, String],
      default: 0
    },
    multiple: {
      type: Boolean,
      default: false
    },
    fileUrl: {
      type: String,
      default: '/base/file/upload'
    }
  },
  setup(props, { emit }) {
    const { fileSize, multiple, filesLength, maxNum } = toRefs(props)
    const items = reactive([])
    const file = ref(null)
    const seleteFiles = async () => {
      const files = file.value.files
      console.log(files.length, filesLength.value, maxNum.value)
      if ((files.length + Number(filesLength.value)) > Number(maxNum.value) && !!Number(maxNum.value)) {
        ElMessage.error('超出最大上传数量限制')
        return
      }
      if (!multiple.value) {
        const file = files[0]
        const isCanUpload = beforeAvatarUpload(file)
        if (isCanUpload) {
          await upload({ file: file }, true)
        }
      } else {
        let arr = Array.from(files)
        arr.forEach((file, i) => {
          let isCanUpload = true
          isCanUpload = beforeAvatarUpload(arr[i])
          if (isCanUpload) {
            setTimeout(async () => {
              await upload({ file: arr[i] }, i == arr.length - 1)
            }, 300 * i)
          }
        })
      }
    }
    const beforeAvatarUpload = (fileItem) => {
      const type = fileItem.name.toLowerCase()
      const index = type.lastIndexOf('.')
      const currentType = type.slice(index + 1, type.length)
      console.log(currentType, 'currentTypecurrentType')
      // const isCanUpload = fileType.value.includes(currentType)
      const isLimit = fileItem.size / 1024 / 1024 < fileSize.value
      // if (!isCanUpload) {
      //   ElMessage.error('不支持当前上传文件格式')
      //   file.value.value = null
      // }
      if (!isLimit) {
        ElMessage.error(`上传大小不能超过${fileSize.value}MB`)
        file.value.value = null
      }
      // return isCanUpload && isLimit
      return isLimit
    }
    // 上传文件
    const upload = (item, isEnd) => {
      return new Promise((resolve, reject) => {
        uploadFile(
          props.fileUrl,
          {
            file: item.file
          },
          (process) => {
            item.process = parseInt(process.replace('%', ''))
          }
        ).then(res => {
          if (res.data) {
            let name = item.file.name
            let curIndex = name.lastIndexOf('.')
            let obj = {
              filePath: res.data.data,
              fileType: name.slice(curIndex+1, name.length),
              fileName: name
            }
            emit('getFiles', obj)
          }
          if (isEnd) {
            file.value.value = null
          }
          resolve(res.data)
        }, (res) => {
          reject(res)
        })
      })
    }
    return { items, file, seleteFiles, beforeAvatarUpload, upload }
  }
})
</script>
<style lang="less" scoped>
.upload {
  position: relative;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  input {
    position: absolute;
    z-index: 2;
    left: 0;
    right: 0;
    // top: 0;
    bottom: 0;
    opacity: 0;
    outline: none;
    cursor: pointer;
  }
}
.fileimg {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  margin-top: -2px;
}
</style>
